export default {
      id: "running_outdoor-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#running_outdoor",
      toString: function () {
        return this.url;
      }
    }